<template>
  <el-dialog
    :visible="!!editingProject"
    title="修改设置"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="150px">
      <el-form-item label="币种：" prop="coinType">
        <span>{{ detail.coinType }}</span>
        <!-- <el-select v-model="detail.coinType">
          <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
        </el-select>-->
      </el-form-item>
      <el-form-item label="最小认购数量" prop="minAmount">
          <el-input-number
            v-model="detail.minAmount"
            :min="0.0001"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最大认购数量" prop="maxAmount">
          <el-input-number v-model="detail.maxAmount" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="精度：" prop="scale">
          <el-input-number v-model="detail.scale" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="认购限额：" prop="limitAmount">
          <el-input-number v-model="detail.limitAmount" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="预期年化收益：" prop="rate">
          <el-input-number v-model="detail.rate" :min="0"></el-input-number>%
        </el-form-item>
        <!-- <el-form-item label="直推奖励：" prop="firstInviteRate">
          <el-input-number
            v-model="detail.firstInviteRate"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="间推奖励：" prop="secondInviteRate">
          <el-input-number
            v-model="detail.secondInviteRate"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item label="产品总量" prop="total">
          <el-input-number
            v-model="detail.total"
            :min="0"
            :step="100"
          ></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="发放币种：" prop="distributionCoinType">
          <el-select v-model="detail.distributionCoinType">
            <el-option
              v-for="item in financialCoinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="支出利息账号：" prop="distributionAccount">
          <el-input
            v-model="detail.distributionAccount"
            placeholder="默认使用平台账号10027"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="币种利率：">
          <mutiple-input v-model="detail.rateConfDto" />
        </el-form-item>
        <el-form-item label="利率规则：" prop="rateRule">
          <el-input type="textarea" v-model="detail.rateRule"></el-input>
        </el-form-item>
        <el-form-item label="产品收益说明：" prop="interestText">
          <el-input type="textarea" v-model="detail.interestText"></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="tagList">
          {{ tagList }}
          <el-row>
            <el-col :span="4"> </el-col>
            <el-col :span="20">
              <el-form
                v-for="(tagItem, index) in tagList"
                :key="index"
                size="mini"
                inline
                lable-width="100px"
              >
              <!-- {{ tagItem }} -->
                <el-row>
                  <el-col :span="23">
                    <el-form-item
                      v-for="item in tagItem"
                      :key="item.lang"
                      :label="item.label"
                    >
                      {{ tagItem.label }}
                      <el-input
                        v-model="tagItem.value"
                        class="width-80"
                        @change="change"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-button
                      size="mini"
                      icon="el-icon-delete"
                      type="danger"
                      circle
                      @click="remove(index)"
                      class="me-2"
                    ></el-button>
                  </el-col>
                </el-row>
              </el-form>
              <el-button
                size="mini"
                icon="el-icon-plus"
                @click="add"
              ></el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="产品图标：" prop="img">
          <upload v-model="detail.img"></upload>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import MutipleInput from '../mutipleInput';
import Upload from 'components/upload';

export default {
  name: 'cornucopiaDetail',
  data() {
    return {
      detail: {
        // rateConfDto: {
        //   rateConf: []
        // }
      },
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        minAmount: {
          required: true,
          message: '请填写'
        },
        maxAmount: {
          required: true,
          message: '请填写'
        },
        scale: {
          required: true,
          message: '请填写'
        },
        firstInviteRate: {
          required: true,
          message: '请填写'
        },
        secondInviteRate: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('cornucopia', ['coinTypeList', 'editingProject']),
    disalbed() {
      return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingProject(val) {
      if (val) {
        this.detail = {
          ...val,
          // rateConfDto: {
          //   rateConf: Object.keys(val.rateConfDto.rateConf).map(key => ({
          //     key,
          //     value: val.rateConfDto.rateConf[key]
          //   }))
          // }
        };
      } else {
        this.detail = {
          // rateConfDto: {
          //   rateConf: []
          // }
        };
      }
    }
  },
  components: {
    MutipleInput,
    Upload
  },
  methods: {
    ...mapMutations('cornucopia', ['setEditingProject']),
    ...mapActions('cornucopia', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      const submitData = {
        ...this.detail,
        // rateConfDto: {
        //   rateConf: this.detail.rateConfDto.rateConf.reduce(
        //     (map, item) => ({
        //       ...map,
        //       [item.key]: item.value
        //     }),
        //     {}
        //   )
        // }
      };
      this.update(submitData).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>
